export const SECTION_TEMPLATES_RESET_STATE = 'SECTION_TEMPLATES_RESET_STATE';
export const SECTION_TEMPLATES_CURRENT_ITEM = 'SECTION_TEMPLATES_CURRENT_ITEM';

export const SECTION_TEMPLATES_REQUEST_LOADING = 'SECTION_TEMPLATES_REQUEST_LOADING';
export const SECTION_TEMPLATES_REQUEST_SUCCESS = 'SECTION_TEMPLATES_REQUEST_SUCCESS';
export const SECTION_TEMPLATES_REQUEST_FAILED = 'SECTION_TEMPLATES_REQUEST_FAILED';

export const SECTION_TEMPLATES_CURRENT_ACTION = 'SECTION_TEMPLATES_CURRENT_ACTION';
export const SECTION_TEMPLATES_RESET_ACTION = 'SECTION_TEMPLATES_RESET_ACTION';